import React from "react";
var __jsx = React.createElement;
import { useTranslation } from "react-i18next";
import { UnstyledButton } from "@mantine/core";
import { trackEvent, ANALYTICS_EVENTS } from "@/utils/analytics";
/** Renders the list of AI-generated decision options; the selected card is highlighted. */
export function DecisionList(_ref) {
  var decisions = _ref.decisions,
    selectedDecisionId = _ref.selectedDecisionId,
    onSelectDecision = _ref.onSelectDecision;
  var _useTranslation = useTranslation(),
    t = _useTranslation.t;
  return /*#__PURE__*/React.createElement("div", {
    className: "flex flex-col gap-3"
  }, decisions.map(function (decision) {
    var isSelected = decision.id === selectedDecisionId;
    return /*#__PURE__*/React.createElement(UnstyledButton, {
      key: decision.id,
      "data-testid": "decision-card-".concat(decision.id),
      onClick: function onClick() {
        trackEvent(ANALYTICS_EVENTS.DECISION_CARD, {
          decisionId: decision.id
        });
        onSelectDecision(decision.id);
      },
      className: "w-full rounded-sds-200 border p-4 flex flex-col gap-2 text-left transition-colors ".concat(isSelected ? "bg-sds-brand-tertiary border-sds-brand-default" : "bg-sds-base-default border-sds-base-default hover:bg-sds-base-secondary")
    }, /*#__PURE__*/React.createElement("div", {
      className: "flex items-center gap-3 flex-wrap"
    }, /*#__PURE__*/React.createElement("span", {
      className: "text-style-body-small-strong text-sds-base-default"
    }, decision.title), decision.recommended && /*#__PURE__*/React.createElement("span", {
      className: "text-style-label-caps text-sds-brand-default bg-sds-base-secondary rounded-sds-full px-2 py-0.5"
    }, t("label.recommended", {
      defaultValue: "Recommended"
    }))), /*#__PURE__*/React.createElement("p", {
      className: "text-style-body-small text-sds-base-secondary"
    }, decision.summary));
  }));
}